import React from 'react';
export function OrangeAccent({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`w-[56px] h-[3px] bg-orange mt-2 ${className}`} data-id="element-100" />;
}